import React from "react";
import { useTranslation } from 'react-i18next';
import ElmaliCloudyBeige from "../Components/quarries/ElmaliCloudyBeige";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function ElmaliCloudyBeigePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.cloudyBeige || {
    title: currentLang === 'tr' ? 'Elmalı Cloudy Beige Mermer - MOCA Mermer' : 'Elmali Cloudy Beige Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'Elmalı Cloudy Beige mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about Elmali Cloudy Beige marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'elmalı cloudy beige, mermer, doğal taş, moca mermer' : 'elmali cloudy beige, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/elmalicloudybeige"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <ElmaliCloudyBeige />
    </>
  );
}

export default ElmaliCloudyBeigePage;
